export const environment = {
  production: false,
  apiGateway: {
    url: "https://api-training.sc.geappl.io/",
    stage: "Yamazumi"
  },
  AllowScreenAuth: false,
  cognitoOptionsHA: [
    {
      Region: "us-east-1",
      ClientId: '6momgtan28o12pevla32ug4pet', // Your client id here
      AppWebDomain: 'mesauth.auth.us-east-1.amazoncognito.com', // Exclude the "https://" part.
      TokenScopesArray: ['openid', 'profile', 'email'],
      UserPoolId: 'us-east-1_s1pKZcsUG',
      AdvancedSecurityDataCollectionFlag: false
    },
    {
      Region: "us-west-2",
      ClientId: '34m5u0nc8vr6ej5hgou9044e6h', // Your client id here
      AppWebDomain: 'mesauth.auth.us-west-2.amazoncognito.com', // Exclude the "https://" part.
      TokenScopesArray: ['openid', 'profile', 'email'],
      UserPoolId: 'us-west-2_R29ioKZps',
      AdvancedSecurityDataCollectionFlag: false
    }
  ],
  SSRSUrl: "http://proficy-reports/ReportServer?"
};